exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect[data-v-1a704af1]{height:150px;overflow-y:auto}.multiselect li[data-v-1a704af1]{padding-bottom:5px;padding-top:5px}.multiselect li label[data-v-1a704af1]:hover{color:currentColor}.multiselect .checkbox[data-v-1a704af1]{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a704af1","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/components/elements/MultiselectField.vue
// module id = +R9D
// module chunks = 0 1